"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFilesRequest = void 0;
/**
 * List Files Request
 * @doc ListFilesRequest
 */
var ListFilesRequest = /** @class */ (function () {
    function ListFilesRequest(data) {
        if (data === void 0) { data = {}; }
        this.pageSize = 20;
        this.orderBy = null;
        this.orderDirection = null;
        if (data.nextPageToken) {
            this.nextPageToken = data.nextPageToken;
        }
        if (data.pageSize) {
            this.pageSize = data.pageSize;
        }
        this.orderBy = data.orderBy || null;
        this.orderDirection = data.orderDirection || null;
        this.type = data.type || null;
    }
    return ListFilesRequest;
}());
exports.ListFilesRequest = ListFilesRequest;
//# sourceMappingURL=list-files-request.js.map